import CESAppInfo from "../CESAppInfo";
import recaptchaElement from "./Recaptcha";
import recaptchaV3Element from "./RecaptchaV3";
import recaptchaEnterpriseElement from "./RecaptchaEnterprise";

export default class RecaptchaFactory {
  private static currentInstance: any = null;
  private static currentVersion: string | null = null;
  private static formId: string | null = null; public static getInstance(newFormId?: string, controlName: string = "recaptcha") {
    const version = CESAppInfo.reCaptchaVer?.toUpperCase();

    // Validate required configuration
    if (!CESAppInfo.reCaptchakey) {
      console.error("reCAPTCHA site key is not configured");
      return null;
    }

    // If version changed or form changed, dispose current instance
    if (this.currentVersion !== version || (newFormId && this.formId !== newFormId)) {
      if (this.currentInstance?.dispose) {
        this.currentInstance.dispose();
      }
      this.currentInstance = null;
      this.currentVersion = version;
      this.formId = newFormId || null;
    }

    if (!this.currentInstance) {
      try {
        switch (version) {
          case 'V3':
            this.currentInstance = recaptchaV3Element.getInstance(controlName);
            break;
          case 'ENTERPRISE':
            this.currentInstance = recaptchaEnterpriseElement.getInstance(controlName);
            break;
          default:
            this.currentInstance = recaptchaElement.getInstance(controlName);
        }
      } catch (error) {
        console.error("Failed to create reCAPTCHA instance:", error);
        return null;
      }
    }

    return this.currentInstance;
  }
};
